
import { environment } from './../../environments/environment';
import * as JSLZString from 'lz-string';
export enum StatusCoordenada {
  CoordenadaRota = 1,
  Sincronizacao = 2,
  Checkin = 3,
  Ocorrencia = 6,
  UltimaLocalizacao = 7,
  Background = 11,
  Foreground = 12,
  Localizacaopause = 13,
  LocalizacaoNovoInicio = 14
}

export enum StatusRoteiro {
  EmAberto = 1,
  Iniciado = 2,
  Pausado = 3,
  Saida = 4,
  Finalizado = 5
}

export enum StatusRoteiroPedidos {
  EmAberto = 1,
  ChegueiEmCliente = 2,
  IniciouAEntrega = 3,
  VoltoDepois = 4,
  RecebimentoRecusado = 5,
  EntregaFinalizada = 6,
  EntregaParcial = 7,
}

export enum StatusEntrega {
  EmAberto = 1,
  ChegouCliente = 2,
  IniciouEntrega = 3,
  VoltoDepois = 4,
  RecebimentoRecusado = 5,
  Finalizado = 6,
  FinalizadoExcecao = 7,
  Parcial = 8,
  ParcialComNaoIniciada = 9,
  ParcialComVoltoDepois = 10,
  ParcialNoCliente = 11
}

export enum CodigoAcaoEnum {
  CoordenadaRota = 1,
  Sincronizacao = 2,
  Checkin = 3,
  InicioEntrega = 4,
  FinalEntrega = 5,
  Ocorrencia = 6,
  UltimaLocalizacao = 7,
  RoteiroIniciado = 8,
  RoteiroPausado = 9,
  RoteiroSaida = 10
}


export interface dbJasperObj {
  IP: string,
  DbName: string
  Nome: string,
  IDServer: number
}

export interface empresaObj{
  cdEmp:number,
  razaoSocial:string,
  NomeFantazia:string,
  cnpj:string
  ativos:boolean
}

export interface jasperObj {
  ID?: string,
  DB: string,
  CONEXAO: string,
  DTINICIO: string,
  DTFIM: string,
  CDEMP:string,
  NUROM:string,
  NOMEMOTORISTA:string
}

export enum reportName {
  TST001 = 'TST001',
  RoteiroEntregasClientePDF ='ROTENTR001',
  RoteiroEntregasClienteEXCEL='ROTENTR002',
  OcorrenciasPDF = 'ROTOC001',
  OcorrenciasEXCEL = 'ROTOC002',
  RoteirosMotoristaPDF = 'ROTPM001',
  RoteirosMotoristaEXCEL = 'ROTPM002',
  OcorrenciasMotoristaPDF = 'ROTOCP001',
  OcorrenciasMotoristaEXCEL = 'ROTOCP002',
  RoteirosDiaPDF="ROTDIA001",
  RoteirosDiaEXCEL="ROTDIA002",
  TempoMedioEntregaClientePDF = 'ROTTC001',
  TempoMedioEntregaClienteEXCEL = 'ROTTC002',
  IntervaloEntregaClientePDF = 'ROTINTC001',
  IntervaloEntregaClienteEXCEL ='ROTINTC002',
  JornadaTrabalhoMotoristaPDF = 'ROTTABM001',
  JornadaTrabalhoMotoristaEXCEL = 'ROTTABM002',
  FormaPagamentoPDF = 'ROTFP001',
  FormaPagamentoEXCEL = 'ROTFP002',
  CustoRoteiroPorEntregaPDF = 'ROTCUF001',
  CustoRoteiroPorEntregaExcel = 'ROTCUF002',
  OcorrenciasCustoExtraPDF = 'OCEXTROT001',
  OcorrenciasCustoExtraEXCEL = 'OCEXTROT002',
  AvaliacaoEntregaMotoristaPDF = 'ROTAVAMOT001',
  AvaliacaoEntregaMotoristaEXCEL = 'ROTAVAMOT002'
}

export enum reportType {
  pdf = 'pdf',
  excel = 'xlsx',
  word = 'docx'
}
export enum conjuntoRelatorios {
  painelMotorista = 'PAINELMOTORISTA',
  ocorrencia = 'OCORRENCIA',
}



export class Util {
  cnpjEmpresas: Array<String> = [];

  public converteData(data: any): Date {
    var dt = new Date(data);
    return new Date(dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset()));
  }

  public static gerarHex() {
      return Math.floor(Math.random() * 0x1000000).toString(16).padStart(6, '0');
  };

  public converterDataSemFuso(data: Date): string {
    let date = new Date(data);
    let year = date.getUTCFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getUTCHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    let monthAux = (month < 10) ? '0' + month : month;
    let dayAux = (day < 10) ? '0' + day : day;
    let hoursAux = (hours < 10) ? '0' + hours : hours;
    let minutesAux = (minutes < 10) ? '0' + minutes : minutes;
    let secondsAux = (seconds < 10) ? '0' + seconds : seconds;

    return year + '-' + monthAux + '-' + dayAux + ' ' + hoursAux + ':' + minutesAux + ':' + secondsAux;
  }

  public retornarDiaSemana(date: Date): any {
    let semana = new Array(7);
    semana[0] = "SEG";
    semana[1] = "TER";
    semana[2] = "QUA";
    semana[3] = "QUI";
    semana[4] = "SEX";
    semana[5] = "SAB";
    semana[6] = "DOM";

    return semana[date.getDay()];
  }

  public calcularDistanciaGeo(lat1, lon1, lat2, lon2) {
    let R = 6371; // Radius of the earth in km
    let dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
    let dLon = this.deg2rad(lon2 - lon1);

    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
      ;

    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c; // Distance in km

    return d;
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180)
  }

  static descricaoStatusRoteiro(codigo) {
    switch (codigo) {
      case 1: return 'Não iniciado';
      case 2: return 'Em rota';
      case 3: return 'Pausado';
      case 4: return 'Sem sinal';
      case 5: return 'Finalizado';
    }
  }

  static descricaoVeiculoEixo(categoriaPedagioID: number) {
    switch (categoriaPedagioID) {
      case 1: return 'motocicleta';
      case 2: return 'auto2eixos';
      case 3: return 'auto3eixos';
      case 4: return 'auto4eixos';
      case 5: return 'caminhao2eixos';
      case 6: return 'caminhao3eixos';
      case 7: return 'caminhao4eixos';
      case 8: return 'caminhao5eixos';
      case 9: return 'caminhao6eixos';
      case 10: return 'caminhao6eixos';
      case 11: return 'caminhao6eixos';
      case 12: return 'caminhao6eixos';
    }
  }

  static obterDimensoesIconePorCategoria(categoriaPedagioID: number) {
    switch (categoriaPedagioID) {
      case 1: return { largura: 33, altura: 24};
      case 2: return { largura: 74, altura: 33};
      case 3: return { largura: 133, altura: 33};
      case 4: return { largura: 133, altura: 33};
      case 5: return { largura: 67, altura: 33};
      case 6: return { largura: 81, altura: 33};
      case 7: return { largura: 101, altura: 33};
      case 8: return { largura: 115, altura: 33};
      case 9: return { largura: 129, altura: 33};
      case 10: return { largura: 129, altura: 33};
      case 11: return { largura: 129, altura: 33};
      case 12: return { largura: 129, altura: 33};
    }
  }


  public DescricaoStatusEntrega(codigo) {
    switch (codigo) {
      case 1: return 'Em Aberto';
      case 2: return 'Chegou no cliente';
      case 3: return 'Iniciou a entrega';
      case 4: return 'Volto depois';
      case 5: return 'Recebimento recusado';
      case 6: return 'Entrega efetuada';
      case 7: return 'Entrega Parcial';
    }
  }

  public DescricaoStatusCoordenada(codigo) {
    switch (codigo) {
      case 1: return 'Coordenada da Rota';
      case 2: return 'Sincronização';
      case 3: return 'Check-in Realizado';
      case 5: return 'Ocorrência reportada';
      case 7: return 'Ultima localização';
      case 11: return 'Coleta de coordenada';
      case 12: return 'Coleta de coordenada';
      case 13: return 'Roteiro Pausado';
      case 14: return 'Roteiro Reativado';
    }
  }

  public formatarCEP(cep: string): string {
    if (cep == undefined || cep == null) {
      return '';
    }

    var resultado = cep.toString();

    if (cep.toString().length == 7) {
      resultado = "0" + cep.toString().substring(0, 4) + "-" + cep.toString().substring(4, 7);
    }
    else if (cep.toString().length == 8) {
      resultado = cep.toString().substring(0, 5) + "-" + cep.toString().substring(5, 8);
    }

    return resultado;
  }

  public formatarDocumento(doc: string): string {
    if (doc == undefined || doc == null || doc == '') {
      return '';
    }

    var resultado = "Documento:" + doc;

    if (doc.length == 14) {
      resultado = "CNPJ: <span>" + doc.substring(0, 2) + "." + doc.substring(2, 5) + "." + doc.substring(5, 8) + "/" + doc.substring(8, 12) + "-" + doc.substring(12, 14) + "</span>";
    }
    else if (doc.length == 11) {
      resultado = "CPF: <span>" + doc.substring(0, 3) + "." + doc.substring(3, 6) + "." + doc.substring(6, 9) + "-" + doc.substring(9, 11) + "</span>";
    }

    return resultado;
  }

  public formataDataMes(mes) {
    if (mes <= 9) {
      return `0${mes}`;
    } else
      return mes;
  }

  public formataDataDia(dia) {
    if (dia <= 9) {
      return `0${dia}`;
    } else
      return dia;
  }

  public formataDataFront(data) {
    let datasplit = data.split('-');
    return `${datasplit[2]}/${datasplit[1]}/${datasplit[0]}`;
  }

  public formataDataBanco(data) {
    let datasplit = data.split('/');
    return `${datasplit[2]}${datasplit[1]}${datasplit[0]}`;
  }

  public secondsToHMS(secs) {
    function z(n) { return (n < 10 ? '0' : '') + n; }
    var sign = secs < 0 ? '-' : '';
    secs = Math.abs(secs);
    return sign + z(secs / 3600 | 0) + ':' + z((secs % 3600) / 60 | 0) + ':' + z(secs % 60 | 0);
  }

  public retornarHora(data: Date): string {
    let hora = data.getHours().toString();
    let minuto = data.getMinutes().toString();

    return (hora.length < 2 ? '0' + hora : hora) + ':' + (minuto.length < 2 ? '0' + minuto : minuto);
  }

  public retornarKm(km: string): string {
    if (km != null) {
      return km + ' km';
    }
    return km;
  }

  public retronarHoraString(hora: string): string {

    if (hora.length == 4) {
      let control = hora.split(':');
      return '0' + control[0] + ':' + control[1]
    }
    return hora;
  }

  dataMesAnterior(): string {
    const data = new Date();
    const ano = data.getUTCFullYear();
    const mes = data.getUTCMonth();
    const dia = data.getUTCDate();
    const dataString = ano + '-' + this.verificaMes(mes) + mes + '-' + this.verificarDia(dia) + dia;
    return dataString;
  }

  dataAtual(): string {
    const data = new Date();
    const ano = data.getUTCFullYear();
    const mes = data.getUTCMonth() + 1;
    const dia = data.getUTCDate();
    const dataString = ano + '-' + this.verificaMes(mes) + mes + '-' + this.verificarDia(dia) + dia;
    return dataString;
  }

  filtroData(data: Date, numero: number): string {
    data.setMonth(data.getMonth() - numero)
    const ano = data.getUTCFullYear();
    const mes = data.getUTCMonth() + 1;
    const dia = data.getUTCDate();
    const dataString = ano + '-' + this.verificaMes(mes) + mes + '-' + this.verificarDia(dia) + dia;
    return dataString;
  }

  verificaMes(id: number): string {
    if (id <= 9) {
      return '0';
    }
    else {
      return '';
    }
  }

  verificarDia(id: number): string {
    if (id <= 9) {
      return '0';
    }
    else {
      return '';
    }
  }

  verificaMensagem(mensagem?: string): string {

    if (mensagem !== null) {
      let msg = mensagem.replace(/(\r\n|\n|\r)/gm, "")
      if (mensagem.includes("<img src")) {
        return '';
      }
      else if (mensagem.length > 40) {
        return msg.substring(0, 40) + '...';
      }
      return msg;
    }
  }

  static compress(data: string) {
    return JSLZString.compressToEncodedURIComponent(data);
  }

  static decompress(data: string){
    return JSLZString.decompressFromEncodedURIComponent(data);
  }

  static converteStringHora(tempo: number){
    let hora: any = Math.floor(tempo / 60);
    let minutos: any = tempo % 60;
    hora = hora < 10 ? '0' + hora : hora;
    minutos = minutos < 10 ? '0' + minutos : minutos;
    return hora + ':' + minutos;
  }

  static converterMinutos(strTempo){
    let splitTempo = strTempo.split(':')
    let minutos = +splitTempo[0] * 60;
    minutos += +splitTempo[1];
    return minutos;
  }

  static formataStringDataJasper(data) {
    var dia  = data.split("/")[0];
    var mes  = data.split("/")[1];
    var ano  = data.split("/")[2];

    return ano + '-' + ("0"+mes).slice(-2) + '-' + ("0"+dia).slice(-2);
    // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
  }

  static calcularDiferencaDias(data1, data2) {
    const dt1 = new Date(data1);
    const dt2 = new Date(data2);
    const formData1 = new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate());
    const formData2 = new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate());
    const diferencaTempo = formData2.getTime() - formData1.getTime(); 
  
    const diferencaDias = diferencaTempo / (1000 * 60 * 60 * 24); 
    return Math.floor(diferencaDias); 
}

static formatarDataHora(str) {
  const date = new Date(str);

  const dia = String(date.getDate()).padStart(2, "0");
  const mes = String(date.getMonth() + 1).padStart(2, "0");
  const ano = date.getFullYear();

  const horas = String(date.getHours()).padStart(2, "0");
  const minutos = String(date.getMinutes()).padStart(2, "0");

  return `${dia}/${mes}/${ano} - ${horas}:${minutos}`;
  }


}

export interface IAvisosNovidades{
  Titulo?: string;
  TextoPrincipal?: string;
  Imagem?: string;
  Url?: string;
  Conteudo?: string;
  SubConteudo?: string;
  TxtBtn?: string;
  OnPressed?: Function;
  MostrarBtn?: boolean;
  ConteudoFooter?: string;
  Pagina?: number;
}


export interface IAlertaPainelInterface {
  NumeroRoteiro?: number;
  AlertaPainelID?: number;
  RoteiroAlertaID?: number,
  PlacaVeiculo?: string,
  CoordenadaID?: number;
  DTAlerta?: string;
  IdStatus?: number;
  NomeMotorista?: string;
  OcorrenciaID?: number;
  RoteiroID?: number;
  TipoAlerta?: string;
  Visualizado?: boolean;
  Latitude?: number;
  Longitude?: number;
  CodigoOcorrencia?: string;
}


export enum IdTipoVeiculo{
  Pedagio = 18
}

export enum TipoAlerta {
  TempoDesconectado = 'Tempo desconectado',
  DesvioDeRota = 'Desvio de rota',
  TempoDeDescarga = 'Tempo de descarga',
  TempoParado = 'Tempo parado',
  VoltoDepoisOuEntregaRecusada = 'Volto depois ou entrega recusada',
  CercaEletronica = 'Cerca Eletrônica',
  TemperaturaMaximaPermitida = 'Temperatura máxima permitida'
}

export enum SituacaoOdometro {
  Inicio = '1',
  Final = '2' 
}

export enum TipoEntregas {
  Entrega = 'ENTREGA',
  Coleta = 'COLETA',
  XmlEntrega = 'XMLENTREGA'
}

export interface DiaRoteiro {
  DT: string;
  HoraCalcAcumuladaT: string;
}

export enum ConfiguracaoInfoCliente {
  RazaoSocial = '1',
  NomeFantasia = '2'
}

export enum TipoRoteiro {
  Padrao = 1,
  Crossdocking = 2
}

export enum TipoApoioLogistico {
  Todos = 'Todos',
}